import { defineComponent as _defineComponent } from 'vue'
import BaseInputNumber from "@/components-UI/BaseInputNumber.vue";
import {
    CONTEST_CASHBACK_MAX_DIGITS,
    CONTEST_CASHBACK_MAX_INT,
} from "@/components_v3/affiliate/contest/shared/config/contest-limits";

interface Props {
    value?: number | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContestOfferGoalBonusInput',
  props: {
    value: { default: null }
  },
  emits: ["update:value"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:value', value: number | null): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, BaseInputNumber, CONTEST_CASHBACK_MAX_DIGITS, CONTEST_CASHBACK_MAX_INT }
}

})